import { usePlaybackCurrentTs } from '@app/core/playback/hooks/usePlayback';
import { WpWordsType } from '@app/modules/search/types';
import { DateTimeStr, Timestamp, toDateTimeStr, toTimestamp } from '@mi-front/core';
import { theme } from '@mi-front/ui';
import { useRef } from 'react';
import styled from 'styled-components';
import { usePlayTranscription } from './useAuditPlayback';

export const SpanStyled = styled.span<{ $isHighlighted?: boolean }>`
  cursor: pointer;
  font-weight: ${(props: any) => (props.$isHighlighted ? 'bold' : 'normal')};
  color: ${(props: any) => (props.$isHighlighted ? theme.aqua : 'black')};
  :hover {
    color: ${theme.aqua};
  }
`;

export function useTranscriptionSync() {
  const audioTimeRef = useRef<Timestamp>(toTimestamp(0));
  const currentTs = usePlaybackCurrentTs();
  const playTranscription = usePlayTranscription();

  const transcriptionPlayerSync = (text: WpWordsType[], isCurrRow: boolean, time: DateTimeStr) => {
    const playTime = async (wordTimestamp: Timestamp) => {
      await playTranscription(toDateTimeStr(wordTimestamp));
      audioTimeRef.current = wordTimestamp;
    };

    const ts = currentTs ?? 0;
    const baseTime = toTimestamp(time);
    const currentTime = ts - baseTime;

    return text.map((item, index) => {
      const isHighlighted = item.start * 1000 <= currentTime && item.end * 1000 > currentTime;

      const startTime = baseTime + item.start * 1000;
      const endTime = baseTime + item.end * 1000;

      return {
        word: item.word,
        start: startTime as Timestamp,
        end: endTime as Timestamp,
        isHighlighted: isHighlighted && isCurrRow,
        onClick: () => playTime(startTime as Timestamp),
      };
    });
  };

  return { transcriptionPlayerSync, timeRef: audioTimeRef };
}
